export type DirectoryBadge = "taaft" | "toolpilot";

// Separate from funnel analytics: never access auth, storage, or visitor identifiers.
export const trackDirectoryBadgeClick = (directory: DirectoryBadge): void => {
  if (typeof window === "undefined" || window.location.pathname !== "/") return;
  if (navigator.doNotTrack === "1" || (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl) return;
  if (directory !== "taaft" && directory !== "toolpilot") return;

  const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
  // The public API key is deliberately used instead of the signed-in session.
  try {
    void fetch(`${import.meta.env.VITE_SUPABASE_URL}/rest/v1/rpc/record_directory_badge_click`, {
      method: "POST",
      headers: { "Content-Type": "application/json", apikey: key, Authorization: `Bearer ${key}` },
      body: JSON.stringify({ p_directory: directory }),
      credentials: "omit",
      referrerPolicy: "no-referrer",
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Tracking is best-effort and must never interrupt the directory link.
  }
};